import en from './en.json';
import fr from './fr.json';

export const defaultLocale = 'fr';
export const locales = { en, fr };
export const availableLocales = ['fr', 'en'];
